import { FC } from "react";

import {
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormMaskedTextFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { Box } from "@mui/material";

interface IBankInfoSetupFieldsPanel {}
export const BankInfoSetupFieldsPanel: FC<IBankInfoSetupFieldsPanel> = ({}) => {
	return (
		<Box
			sx={{
				padding: "0",
			}}
		>
			<RHookFormMaskedTextFieldWithLabel
				label="Bank Code"
				id="bankCode"
				testId={`bank-coed`}
				labelPosition={LabelPosition.Top}
				placeholder={"0000"}
				inputMaskPattern={"0000"}
			/>
			<RHookFormTextFieldWithLabel
				label="Bank Name"
				id="bankName"
				testId={`bank-nmae`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormTextFieldWithLabel
				label="Bank Domain"
				id="bankDomain"
				testId={`bank-domain`}
				labelPosition={LabelPosition.Top}
				// labelColumns={4}
				// fieldColumns={7}
				// required
			/>
		</Box>
	);
};
